import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import './index.css'
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';

//Redux
import { useSelector } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { RootState } from '../../../store/index';

import LcLoading from '../../../components/Generic/LcLoading';
import { SaasService } from '../../../services/saas/saasService';
import LcDropDown from '../../../components/Generic/LcDropDown';
import LcNoData from '../../../components/Generic/LcNoData';
import LCDashboard, { Card } from '../../../components/Data/Dashboard/LCDashboard';
import IconValue from '../../../components/Layout/Dashboard/IconValue';
import { PiBrowsersBold, PiCubeBold, PiDevicesBold, PiLightningBold, PiUsersBold } from 'react-icons/pi';
import { LCTechService } from '../../../services/LCTechService';
import LcIconLink from '../../../components/Generic/LcIconLink';
import PPDropDown from '../../../components/PPDropDown';
import SubscriptionComercial from './SubscriptionComercial';
import moment from 'moment';
import ActiveChartPerSoftware from './ActiveChartPerSoftware';
import EventsGraph from '../../endpointDetectionResponse/resumeEvent/EventsGraph';
import { Chart } from '../../endpointDetectionResponse/resumeEvent/Models';
import SoftwareAccountsByMonth from './SoftwareAccountsByMonth';
import PivotTableWebix from '../../../components/webix';
import { SaasUserService } from '../../../services/SaasUserService';
import { SubscriptionData, ActivationChartModel, SoftawareAcoountByMonthModel, SuggestionsSubscriptionModel, ActiveInfoModel, DomainInfoModel } from '../../../services/saas/SaasModel';


const Insights: React.FC = (props) => {

    const user = useSelector<RootState, UserState>(state => state.user);

    const saasService = new SaasService(props);
    const lcTechService = new LCTechService(props);
    const SaaS_ServiceUSer = new SaasUserService(props);
    const [activeDivices, setActiveDivices] = useState<number>(0);
    const [activeAcounts, setActiveAcounts] = useState<number>(0);
    const [distinctSoftwares, setDistinctSoftwares] = useState<number>(0);
    const [domainCount, setDomainCount] = useState<number>(0);
    const [domainLabel, setDomainLabel] = useState<boolean>(false);
    const [quantityAccountsLabel, setQuantityAccountsLabel] = useState<boolean>(false);
    const [activationsLabel, setActivationsLabel] = useState<boolean>(false);
    const [subiscriptionsLabel, setSubiscriptionsLabel] = useState<boolean>(false);
    const [optionLicensesContratadasLoading, setOptionLicensesContratadasLoading] = useState<any>(true);
    const [subiscriptionData, setSubiscriptionData] = useState<SubscriptionData>()
    const [subscriptionSuggestions, setSubscriptionSuggestions] = useState<SuggestionsSubscriptionModel[]>([])
    const [activeChartData, setActiveChartData] = useState<Chart>();
    const [activationsChartData, setActivationsChartData] = useState<ActivationChartModel[]>([]);
    const [softawareAccountByMonthData, setSoftwareAccountByMonthData] = useState<SoftawareAcoountByMonthModel[]>([])
    const [domainsInfo, setDomainsInfo] = useState<DomainInfoModel>()
    const [formattedData, setFormattedData] = useState<any[]>();
    const [expandedData, setExpandedData] = useState<any[]>();
    const [pivotlicensesFocus, setPivotlicensesFocus] = useState<boolean>(false);
    const [pivotlicensesFocusContasAtivas, setPivotlicensesFocusContasAtivas] = useState<boolean>(false);
    const [activetionsReport, setActivationsReport] = useState<ActiveInfoModel>()
    const [monthPeak, setMonthPeak] = useState<number>(Number(moment().month()))

    const ActiveOpt = [
        { label: 'Por software', value: 0 },
        { label: 'Por dispositivo', value: 1 },
    ]
    const [activeView, setActiveView] = useState<number>(0)
    //Carregar esses dados do banco no futuro
    const dashs = [
        { id: '6a5117dc-e405-4451-a862-96e62dcd62c4', name: 'Ativos de Software' },
        // { id: 'b13d2b25-f357-44e6-adac-680a6626e7f0', name: 'Email' },
        // { id: '051fc101-e146-45cb-8e66-ed09b621afc0', name: 'One Drive' }
    ]

    const [loading, setLoading] = useState<boolean>(false);
    const [dashSelected, setDashSelected] = useState<{ id: string, name: string }>(dashs[0]);
    const [dashData, setDashData] = useState<{
        embedUrl: string
        requestId: string
        status: number
    } | undefined>();
    const month = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]

    useEffect(() => {
        setLoading(true);
        const alPromisses = [getActiveDevicesAndSoftwares(), getActiveCountPerDays(90), getDomains(), loadUsers()];
        Promise.all(alPromisses)
            .catch(error => console.error(error))
            .finally(() => setLoading(false))
    }, [user.refreshFlag, user.ClientGroupSelected])

    const getActiveDevicesAndSoftwares = async () => {
        await saasService.GetActivationChart().then(response => {
            let initialValue = 0
            if (response.data) {
                setActiveDivices(response.data.reduce((accumulator, current) => accumulator + current.android + current.iOS + current.mac + current.windows + current.windows10Mobile
                    , initialValue))
                setActivationsReport(getActiveReport(response.data))
                setActiveChartData(buildActiveChartData(response.data))
                setActivationsChartData(response.data)

            }
        }).catch((error) => console.error(error))
    }

    const getActiveCountPerDays = async (days: number) => {
        await saasService.GetUsersChart(days).then(response => {
            if (response.data) {
                setSoftwareAccountByMonthData(response.data)
            }
        }).catch((error) => console.error(error))
    }

    const getDomains = async () => {
        setOptionLicensesContratadasLoading(true)
        await lcTechService.Retrieve(1).then(response => {
            setSubiscriptionData(response.data)
            setDomainCount(response.data.domains.length)
            setSubscriptionSuggestions(getSubscriptionSuggestions(response.data.subscriptions.filter(subs => subs.consumedUnits < subs.prepaidUnid)))
        })
            .catch((error) => console.error(error))
            .finally(() => setOptionLicensesContratadasLoading(false))
    }

    const getSubscriptionSuggestions = (subscription: any) => {
        return subscription.map(subs => {
            return {
                displayName: subs.displayName,
                percentege: (((subs.prepaidUnid - subs.consumedUnits) / subs.prepaidUnid) * 100).toFixed(1).toString() + "%",
                prepaidUnid: subs.prepaidUnid,
                consumedUnits: subs.consumedUnits,
            }
        })
    }

    const loadUsers = async () => {
        try {
            var data = await SaaS_ServiceUSer.GetUserServices();
            //const originalData = resultUsers && resultUsers.data;

            setActiveAcounts(data.userCount);

            setDomainsInfo(data.domains);
            setDistinctSoftwares(data.softwares);
            var expandedDataLocal: any[] = [];
            expandedDataLocal = data.pivot; 

            setExpandedData(expandedDataLocal);
            setFormattedData(expandedDataLocal);
        } catch (e) {
            console.error(e);
        }
    }  

    const buildActiveChartData = (data): any => {
        const platformColors = {
            'Windows': '#0078d6',
            'Windows 10 Mobile': '#19588d',
            'IOS': '#777777',
            'Mac': '#1d1d1f',
            'Android': '#a4ca39',
        };

        const counts = {
            'Windows': 0,
            'Windows 10 Mobile': 0,
            'IOS': 0,
            'Mac': 0,
            'Android': 0,
        };

        // Calcular contagens de cada plataforma
        data.forEach(({ iOS, windows, android, windows10Mobile, mac }) => {
            counts['Windows'] += windows;
            counts['Windows 10 Mobile'] += windows10Mobile;
            counts['IOS'] += iOS;
            counts['Android'] += android;
            counts['Mac'] += mac;
        });

        // Construir os dados formatados
        const newActiveData = Object.entries(counts)
            .filter(([platform, count]) => count > 0)
            .map(([platform, count]) => ({
                value: count,
                name: platform,
                itemStyle: {
                    color: platformColors[platform]
                }
            }));

        return newActiveData;
    };
    const getActiveReport = (arrayDeObjetos) => {
        let ativacoesPorProductType = {};
        let ativacoesPorDispositivo = {
            android: 0,
            iOS: 0,
            windows: 0,
            mac: 0,
            windows10Mobile: 0
        };
        let productTypeMaisAtivado = "";
        let totalAtivacoes = 0;
        let totalAtivacoesProductTypeMaisAtivado = 0;
        let productTypesSemAtivacao: any = [];
        let dispositivoMaisAtivado = "";

        arrayDeObjetos.forEach(objeto => {
            let productType = objeto.productType;
            let totalDispositivos = 0;

            Object.keys(ativacoesPorDispositivo).forEach(dispositivo => {
                totalDispositivos += objeto[dispositivo] || 0;
            });

            totalAtivacoes += totalDispositivos;

            if (totalDispositivos > 0) {
                ativacoesPorProductType[productType] = (ativacoesPorProductType[productType] || 0) + totalDispositivos;
                if (ativacoesPorProductType[productType] > totalAtivacoesProductTypeMaisAtivado) {
                    totalAtivacoesProductTypeMaisAtivado = ativacoesPorProductType[productType];
                    productTypeMaisAtivado = productType;
                }
            } else {
                productTypesSemAtivacao.push(productType);
            }

            Object.keys(ativacoesPorDispositivo).forEach(dispositivo => {
                ativacoesPorDispositivo[dispositivo] += objeto[dispositivo] || 0;
            });
        });

        dispositivoMaisAtivado = Object.keys(ativacoesPorDispositivo).reduce((a, b) => ativacoesPorDispositivo[a] > ativacoesPorDispositivo[b] ? a : b);

        let porcentagemDispositivoMaisAtivado = (ativacoesPorDispositivo[dispositivoMaisAtivado] / totalAtivacoes) * 100;

        return {
            productTypeMaisAtivado: productTypeMaisAtivado.charAt(0).toUpperCase() + productTypeMaisAtivado.slice(1).toLowerCase(),
            totalAtivacoes,
            totalAtivacoesProductTypeMaisAtivado,
            porcentagemDispositivoMaisAtivado,
            productTypesSemAtivacao: productTypesSemAtivacao.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()),
            dispositivoMaisAtivado: dispositivoMaisAtivado.charAt(0).toUpperCase() + dispositivoMaisAtivado.slice(1).toLowerCase(),
            totalAtivacoesDispositivoMaisAtivado: ativacoesPorDispositivo[dispositivoMaisAtivado],
        };
    }

    const cards: Card[] = [
        //Contas ativas
        {
            id: 1,
            type: 'Custom',
            position: { ColSpan: 2, RowSpan: 1, row: 1, col: 1 },
            showFocusButton: true,
            title: () => "Contas ativas",
            customContentRender: (focused?: boolean) => {
                setPivotlicensesFocusContasAtivas(focused == true);
                if (focused) {

                    var fieldBase = [
                        { id: 'disName', value: "Usuario", type: "text" },
                        { id: 'userPrincipalName', value: "Email", type: "text" },
                        { id: 'jobTitle', value: "Cargo", type: "text" },
                        { id: 'lncs', value: "Subscrição", type: "text" },
                        { id: 'sku', value: "SKU", type: "text" },
                        { id: 'count', value: "Atribuída", type: "number" },
                        { id: 'avali', value: "Contratada", type: "number" }
                    ];
                    return <><LcLoading loading={loading}>{formattedData && formattedData.length > 0 ?
                            <PivotTableWebix
                                idView={"Contas ativas" }
                                showAllNumbersAsInteger={true}
                                maxY={false}
                                minY={false}
                                maxX={false}
                                minX={false}
                                footer={true}
                                key={"Contas ativas"}
                                data={formattedData}
                                fields={fieldBase}
                                mode="tree"
                                chart={{ scale: 'logarithmic', yAxis: { start: 0 } }}
                                style={{ marginTop: '-10px'}}
                                structure={{
                                    rows: ["disName"],
                                    columns: ["lncs"],
                                    values: [{ name: "count", operation: ["count"] }, { name: "avali", operation: ["max"] }],
                                    filters: [{ name: "lncs" }, { name: "disName" }]
                                }}
                            />
                            : <LcNoData />
                    }</LcLoading></>
                } else {
                    setPivotlicensesFocus(false);
                    return (
                        <LcLoading loading={loading}>
                            {
                                activeAcounts ?
                                    <IconValue icon={<PiUsersBold size={'2rem'} />} value={activeAcounts} color='#141b4d' />
                                    :
                                    <LcNoData size='small' />
                            }
                        </LcLoading>
                    )

                }
            }
        },
        //Dispositivos ativas
        {
            id: 2,
            type: 'Custom',
            position: { ColSpan: 2, RowSpan: 1, row: 1, col: 3 },
            showFocusButton: false,
            title: () => "Dispositivos ativos",
            customContentRender: (focused?: boolean) => {

                if (focused) {
                    return <div></div>
                } else {
                    return (
                        <LcLoading loading={loading}>
                            {
                                activeDivices ?
                                    <IconValue icon={<PiDevicesBold size={'2rem'} />} value={activeDivices} color='#141b4d' />
                                    :
                                    <LcNoData size='small' />
                            }
                        </LcLoading>
                    )

                }
            }
        },
        //Subscrições distintas
        {
            id: 3,
            type: 'Custom',
            position: { ColSpan: 2, RowSpan: 1, row: 1, col: 5 },
            showFocusButton: true,
            title: () => 
             <div className="lc-segment-title-row-resume">
                <div className="lc-title ellipsis">Subscrições distintas</div>
            </div>,
            customContentRender: (focused?: boolean) => {
                setPivotlicensesFocus(focused == true);
                if (focused) {
                    var fieldBase = [
                        { id: 'disName', value: "Usuario", type: "text" },
                        { id: 'userPrincipalName', value: "Email", type: "text" },
                        { id: 'jobTitle', value: "Cargo", type: "text" },
                        { id: 'lncs', value: "Subscrição", type: "text" },
                        { id: 'sku', value: "SKU", type: "text" },
                        { id: 'count', value: "Atribuída", type: "number" },
                        { id: 'avali', value: "Contratada", type: "number" }
                    ];
                    //disName: user.displayName.trim(),
                    //      userPrincipalName: user.userPrincipalName,
                    //      jobTitle: user.jobTitle,
                    //      lncs: licence.trim(),
                    //      sku: skusArray[index].trim(),
                    //      avali: Number(skuPartPrepaidUnitsArray[index].trim()),
                    //      count: 1,
                    return <><LcLoading loading={loading}>{formattedData && formattedData.length > 0 ?
                    
                            <PivotTableWebix 
                                idView={"Softwares distintos"}
                                showAllNumbersAsInteger={ true}
                                maxY={false}
                                minY={false}
                                maxX={false}
                                minX={false}
                                footer={false}
                                key={"Softwares distintos"}
                                data={formattedData}
                                fields={fieldBase}
                                mode="tree"
                                chart={{ scale: 'logarithmic', yAxis: { start: 0 } }}
                                style={{ marginTop: '-10px' }}
                                structure={{
                                
                                    rows: ["lncs"],
                                    values: [{ name: "count", operation: ["count"] }, { name: "avali", operation: ["max"] }],
                                    filters: [{ name: "lncs" }, { name: "disName" }]
                                }}
                            /> : <LcNoData />
                    }</LcLoading></>
                } else {
                    return (
                        <LcLoading loading={loading}>
                            {
                                distinctSoftwares ?
                                    <IconValue icon={<PiCubeBold size={'2rem'} />} value={distinctSoftwares} color='#141b4d' />
                                    :
                                    <LcNoData size='small' />
                            }
                        </LcLoading>
                    ) 
                }
            }
        },
        //Domínios
        {
            id: 4,
            type: 'Custom',
            position: { ColSpan: 2, RowSpan: 1, row: 1, col: 7 },
            ticketButton: () => <LcIconLink backgroundClickble='#F0F3FF' icon={'ppi ppi-lightning-bolt'} onClick={() => setDomainLabel(!domainLabel)} clickble={domainLabel} degrade  tooltip='LiveCloud AI' tooltipPosition='right'/>,
            showFocusButton: false,
            title: () => "Domínios",
            customContentRender: (focused?: boolean) => {
                return (
                    <LcLoading loading={loading}>
                        {
                            domainCount ?
                                <>
                                    <IconValue cssClass={`iconValueInsights ${domainLabel ? '' : 'show'}`} icon={<PiBrowsersBold size={'2rem'} />} 
                                        value={domainCount} color='#141b4d' />
                                    <div className={`row domainsInsights ${domainLabel ? 'show' : ''}`}>
                                    <i className='ppi ppi-lightning-bolt' style={{fontSize: '20px'}}></i>
                                        <p style={{wordBreak: 'break-word'}} className='ml-3'>O maior é <strong>{domainsInfo?.mostComumDomain}</strong>, com {domainsInfo?.porcentege} ({domainsInfo?.quantity}) dos usuários </p>
                                    </div>
                                </>
                                :
                                <LcNoData size='small' />
                        }
                    </LcLoading>
                )
            }
        },
        //Subscrições
        {
            id: 5,
            type: 'Custom',
            position: { RowSpan: 2, ColSpan: 4, row: 1, col: 9 },
            title: () =>
                <div className="lc-segment-title-row-resume">
                    <div className="lc-title ellipsis">Subscrições</div>
                </div>,
            ticketButton: () => <LcIconLink icon={'ppi ppi-lightning-bolt'} backgroundClickble='#F0F3FF' 
                onClick={() => setSubiscriptionsLabel(!subiscriptionsLabel)} degrade clickble={subiscriptionsLabel}  tooltip='LiveCloud AI' tooltipPosition='right'/>,
            customContentRender: (focused?: boolean) =>
                <LcLoading loading={optionLicensesContratadasLoading}>
                    {
                        subiscriptionData && subiscriptionData.subscriptions.length > 0?
                        <>
                            <div style={{height: '100%'}} className={`iconValueInsights ${subiscriptionsLabel ? '' : 'show'}`}>
                                    <SubscriptionComercial subscriptionData={subiscriptionData}/>
                            </div>
                            <div className={`row subscriptionInsights ${subiscriptionsLabel ? 'show' : ''} scrollable-v` }>
                                {  
                                    subscriptionSuggestions  && subscriptionSuggestions.length > 0 &&
                                    subscriptionSuggestions.map(subs => {
                                        return (
                                            <div className='row'>
                                                <i className='ppi ppi-lightning-bolt' style={{fontSize: '20px'}}></i>
                                                {/* <PiLightningBold size={'2rem'} color='#898da6' /> */}
                                                <p className='ml-5'><strong>{subs.displayName}</strong> tem {subs.percentege} das atribuições disponiveis {`(${subs.consumedUnits} de ${subs.prepaidUnid} estão em uso)`}</p>
                                            </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                            :
                            <LcNoData />
                    }
                </LcLoading>
        },
        //Quantidade de contas por principais softwares
        {
            id: 6,
            type: 'Custom',
            position: { RowSpan: 3, ColSpan: 8, row: 2, col: 1 },
            title: () => `Quantidade de contas por principais softwares em ${month[monthPeak]}`,
            ticketButton: () => <LcIconLink backgroundClickble='#F0F3FF' icon={'ppi ppi-lightning-bolt'} degrade onClick={() => setQuantityAccountsLabel(!quantityAccountsLabel)} 
            clickble={quantityAccountsLabel}  tooltip='LiveCloud AI' tooltipPosition='right'/>,
            customContentRender: (focused?: boolean) =>
                <LcLoading loading={optionLicensesContratadasLoading}>
                    {
                        softawareAccountByMonthData && softawareAccountByMonthData.length > 0 ?
                            <SoftwareAccountsByMonth data={softawareAccountByMonthData} showInfo={quantityAccountsLabel} setMonth={setMonthPeak} />
                            :
                            <LcNoData />
                    }
                </LcLoading>
        },
        //Ativações
        {
            id: 6,
            type: 'Custom',
            position: { RowSpan: 2, ColSpan: 4, row: 3, col: 9 },
            title: () => <div className="lc-segment-title-row-resume">
                <div className="lc-title ellipsis">Ativações</div>
                <PPDropDown
                    options={ActiveOpt}
                    onChange={(e) => {
                        e.value === '' ? setActiveView(0) : setActiveView(e.value);
                    }} 
                    defaultValue={ActiveOpt.find(option => option.value == activeView)}
                    value={ActiveOpt.find(option => option.value == activeView)}
                    width={'190px'}
                />
            </div>,
            ticketButton: () => <LcIconLink icon={'ppi ppi-lightning-bolt'} degrade onClick={() => setActivationsLabel(!activationsLabel)} clickble={activationsLabel} 
            backgroundClickble='#F0F3FF' color={!activationsLabel ? '#75f983' : "#000"}  tooltip='LiveCloud AI' tooltipPosition='right' />,

            customContentRender: (focused?: boolean) =>
                <LcLoading loading={loading}>
                    {
                        activationsChartData && activeChartData ?
                            <div style={{ height: '100%' }} className={`iconValueInsights ${activationsLabel ? '' : 'show'}`}>
                                {
                                    activeView === 0 ?
                                        <ActiveChartPerSoftware data={activationsChartData} />
                                        :
                                        activeChartData &&
                                        <EventsGraph data={activeChartData} />
                                }
                            </div>
                            :
                            <LcNoData />
                    }
                    <div className={`row subscriptionInsights ${activationsLabel ? 'show' : ''} scrollable-v`}>
                        {
                            activetionsReport ?
                                <>
                                    <div className='row mb-5'>
                                        <i className='ppi ppi-lightning-bolt' style={{fontSize: '20px'}}></i>
                                        <p className='ml-5'>Os dispositivos <strong>{activetionsReport?.dispositivoMaisAtivado}</strong> recebeu {activetionsReport?.totalAtivacoesDispositivoMaisAtivado} ativações
                                            em {month[Number(moment().month())]}, cerca de {activetionsReport?.porcentagemDispositivoMaisAtivado.toFixed(1)} das {activetionsReport?.totalAtivacoes} ativações realizadas no período </p>
                                    </div>
                                    <div className='row mb-5'>
                                        <i className='ppi ppi-lightning-bolt' style={{fontSize: '20px'}}></i>
                                        <p className='ml-5'><strong>{activetionsReport?.productTypeMaisAtivado}</strong> foi o software mais ativado em março,
                                            com {activetionsReport?.totalAtivacoesProductTypeMaisAtivado} das {activetionsReport?.totalAtivacoes}</p>
                                    </div>
                                    {
                                        activetionsReport && activetionsReport.productTypesSemAtivacao.length > 0 &&
                                        <div className='row mb-2'>
                                            {/* <PiLightningBold size={'2rem'} color='#898da6' /> */}
                                            <i className='ppi ppi-lightning-bolt' style={{fontSize: '20px'}}></i>
                                            <p className='ml-5'><strong>{activetionsReport?.productTypesSemAtivacao.length > 1 ?
                                                activetionsReport?.productTypesSemAtivacao.join(', ') : activetionsReport?.productTypesSemAtivacao.join(' ')} </strong>
                                                não {activetionsReport?.productTypesSemAtivacao.length > 1 ? 'foram ativados' : 'foi ativado'} nenhuma vez em  {month[Number(moment().month())]}</p>
                                        </div>
                                    }
                                </>
                                :
                                <LcNoData />
                        }
                    </div>
                </LcLoading>
        },
    ];

    return (
        <Layout
            pageTitle="Insights"
            pivot={pivotlicensesFocus || pivotlicensesFocusContasAtivas}
            row={
                <LcDropDown
                    element={<span>{dashSelected.name} <i className="ppi ppi-chevron-down" /></span>}
                    position="rigth"

                >
                    {
                        dashs.map((d, i) => {
                            return <div key={i} className={`item${dashSelected.id == d.id ? " disabled" : ""}`} onClick={() => { setDashSelected(d) }}>{d.name}</div>
                        })
                    }
                </LcDropDown>
            }
        >
            <LCDashboard cards={cards} />
        </Layout>
    );
}

export default Insights;